import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { forwardRef, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputPhoneProps {
    label: string;
    extraText?: string;
    isRequired: boolean;
    initValue?: string;
}

const InputPhone = forwardRef((props: InputPhoneProps, ref) => {

    const [text, setText] = useState<string>(props.initValue ?? "");
    const [textError, setTextError] = useState<string>("");
    const validateText = () => {
        if (props.isRequired && !text) {
            setTextError(`${props.label} jest wymagane`);
            return false;
        } else if(!(/^(?:(?:[0+]48 )?\d{3} \d{3} \d{3}|\+\d{2,3} [\d ]{7,12}\d{1}|\d{9})$/.test(text))) {
            setTextError(`Podana wartość w polu ${props.label} nie pasuje do wzoru telefonu 123123123 lub +48 123 123 123 lub 123 123 123 lub numer zagraniczny`);
            return false;
        } else {
            setTextError("");
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateText(),
        value() { return text; }
    }));

    return (
        <FormControl isInvalid={!!textError}
            mt="5"
        >
            <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
            {props.extraText ? <>{props.extraText}</> : <></>}
            <Input
                type="text"
                placeholder="123123123"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onBlur={validateText}
            />
            <FormErrorMessage>{textError}</FormErrorMessage>
        </FormControl>
    );
});

export default InputPhone;
